/** Тема админ-панели: auto (как в системе), light или dark. Выбор хранится в браузере. */
export type Theme = 'auto' | 'light' | 'dark';
const KEY = 'qm_admin_theme';

export function getTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'auto';
  } catch {
    return 'auto';
  }
}

export function applyTheme(t: Theme = getTheme()) {
  if (t === 'auto') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = t;
}

export function isDark(): boolean {
  const t = getTheme();
  return t === 'dark' || (t === 'auto' && window.matchMedia?.('(prefers-color-scheme: dark)').matches === true);
}

/** Переключить светлую/тёмную тему (явный выбор пользователя). */
export function toggleTheme(): Theme {
  const next: Theme = isDark() ? 'light' : 'dark';
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* приватный режим — тема до перезагрузки */
  }
  applyTheme(next);
  return next;
}
